module.exports = __webpack_public_path__ + "static/media/new_jardin_privado_17182023.12ca7239.png";